import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Typography, DatePicker, Avatar, Row, Col, Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment';
import men from '../../../../assets/images/profile/men.png'
import women from '../../../../assets/images/profile/women.png'
import AvatarProfile from '../../AvatarProfile'
import logo from '../../../../assets/images/vtrc-logo.png'
import profile from '../../../../assets/images/profile/img-profile.jpg'

const { Text, Title } = Typography


class LoginForm extends React.PureComponent {
	handleSubmit = e => {
		const { form, afterSubmit } = this.props
		e.preventDefault()
		form.validateFields((err, values) => {
			if (!err && afterSubmit) {
				afterSubmit(values)
				// window.location.href = '/login'
			}
		})
	}

	cancle() {
		sessionStorage.clear()
		localStorage.clear()
		// window.location.href = '/verify/user'
		window.location.href = '/login'
	}

	compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
            callback('รหัสผ่านและยืนยันรหัสผ่านต้องตรงกัน');
        } else {
            callback();
        }
    };

	render() {
		const { form, autoFocus, firstName, lastName, positionName, gender, orgUnitName } = this.props
		const { getFieldDecorator } = form

		return (
			<Form style={{ maxWidth: 600, width: 500 }}>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 20 }}>
					<img src={logo} alt="logo" className="logo-formlogin"  />
				</div>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 20 }}>
					<div style={{ width: '150px' }}>
						{
							// <AvatarProfile imgProfile={gender == "Female" ? women : men} />
						}
					</div>
				</div>
				<div style={{ textAlign: 'center', marginTop: 10, marginBottom: 50 }}>
					<Title level={3} style={{ marginBottom: '0' }}>กรอกข้อมูลผู้ใช้งาน</Title>
					<b className="color-gary" style={{ margin: '0' }}>กรอกข้อมูล</b><br></br>
				</div>

				{/* <Form.Item label={<b>ชื่อ-นามสกุล</b>} name="name" style={{ marginBottom: '0' }}>
					<div
						className={'divshowname'}
						style={{ borderRadius: '100px' }}
						width='100%'
					>
						<div style={{ marginLeft: '12px' }}>{firstName} {lastName}</div>
					</div>
				</Form.Item>
				<Form.Item label={<b>ตำแหน่ง</b>} name="position" style={{ marginBottom: '0' }}>
					<div
						className={'divshowname'}
						style={{ borderRadius: '100px' }}
						width='100%'
					>
						<div style={{ marginLeft: '12px' }}>{positionName}</div>
					</div>
				</Form.Item> */}
				<Row>
					<Col span={1}>
						<Icon style={{fontSize:"20px"}} type="user" />
					</Col>
					<Col span={22}>
						<div style={{ marginLeft: '12px' }}>
							<h4>
								ชื่อ : {firstName} {lastName}
							</h4>
						</div>
					</Col>
				</Row>
				<Row className="mt-3">
					<Col span={1}>
						<Icon style={{fontSize:"20px"}} type="idcard" />
					</Col>
					<Col span={22}>
						<div style={{ marginLeft: '12px' }}>
							<h4>
								ตำแหน่ง : {positionName}
							</h4>
						</div>
					</Col>
				</Row>
				<Row className="mt-3">
					<Col span={1}>
						<Icon style={{fontSize:"20px"}} type="deployment-unit" />
					</Col>
					<Col span={22}>
						<div style={{ marginLeft: '12px' }}>
							<h4>
								หน่วยงาน : {orgUnitName}
							</h4>
						</div>
					</Col>
				</Row>

				<Form.Item className="mt-2" label={<b>ตั้งรหัสผ่าน</b>} name="password" style={{ marginBottom: '0' }}>
					<div style={{ position:"absolute", right:"5px", top:"-43px" }}>
						<Tooltip placement="topLeft" title={<Text className="color-white">รหัสผ่านต้องมีความยาวตั้งแต่ 8 ตัวขึ้นไปและต้องมีอักขระและตัวอักษรพิมพ์ใหญ่และพิมพ์เล็กอย่างน้อย 1 ตัว</Text>}>
							<Icon type="info-circle" />
						</Tooltip>
					</div>
					{getFieldDecorator('password', {
						rules: [{ required: true, message: 'กรุณาใส่รหัสผ่าน' }]
					})(
						<Input.Password
							style={{ borderRadius: '100px' }}
							autoFocus={autoFocus}
							type="password"
							placeholder=""
						/>
					)}
				</Form.Item>
				<Form.Item label={<b>ยืนยันรหัสผ่าน</b>} name="confirmpassword" >
					{getFieldDecorator('confirmpassword', {
						rules: [
							{ required: true, message: 'รหัสผ่านและยืนยันรหัสผ่านต้องตรงกัน' },
							{
								validator: this.compareToFirstPassword,
							}
						]
					})(
						<Input.Password
							style={{ borderRadius: '100px' }}
							type="password"
							placeholder=""
							onPaste={(e)=>
								e.preventDefault()
							}
						/>
					)}
				</Form.Item>
				<Form.Item style={{ textAlign: 'center', marginBottom: 30, marginTop: 50 }}>
					<Button type="primary btn-color-transparent btn-custom btn-cutom-width mb-2" htmlType="submit" onClick={this.handleSubmit} style={{ marginRight: 10 }}>
						ยืนยัน
					</Button>
					<Button type="primary btn-color-cancle btn-custom btn-cutom-width mb-2" onClick={this.cancle}>
						<Text>ยกเลิก</Text>
					</Button>
				</Form.Item>
			</Form>
		)
	}
}

LoginForm.defaultProps = {
	autoFocus: false
}

LoginForm.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedLoginForm = Form.create()(LoginForm)

export default WrappedLoginForm
